import React, { useState } from 'react';
import { Button } from '../UI';
import {
  GettingStartedSection,
  PasswordManagementSection,
  SearchSortSection,
  TagsSection,
  ShareSection,
  SecuritySection,
  SettingsSection,
  AdvancedSection,
  TipsSection
} from './sections';
import './UserGuide.css';

/**
 * 사용자 가이드 페이지
 * NewPass2의 모든 기능에 대한 상세한 사용법 제공
 * 
 * 600라인 룰 준수를 위해 섹션별 컴포넌트로 분할
 */
function UserGuide() {
  const [activeSection, setActiveSection] = useState('getting-started');

  // 네비게이션 메뉴
  const sections = [
    { id: 'getting-started', title: '시작하기', icon: '🚀' },
    { id: 'password-management', title: '패스워드 관리', icon: '🔐' },
    { id: 'search-sort', title: '검색 & 정렬', icon: '🔍' },
    { id: 'tags', title: '태그 시스템', icon: '🏷️' },
    { id: 'share', title: '패스워드 공유', icon: '🔗' },
    { id: 'security', title: '보안 기능', icon: '🛡️' },
    { id: 'settings', title: '설정', icon: '⚙️' },
    { id: 'advanced', title: '고급 기능', icon: '🎯' },
    { id: 'tips', title: '팁 & 트릭', icon: '💡' }
  ];

  const scrollToSection = (sectionId) => {
    setActiveSection(sectionId);
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="user-guide-page">
      {/* 헤더 */}
      <header className="guide-header">
        <div className="guide-container">
          <h1>📖 PW-Wallet 사용자 가이드</h1>
          <p className="guide-subtitle">
            안전하고 편리한 패스워드 관리를 위한 완전한 가이드
          </p>
          <div className="guide-stats">
            <div className="stat-item">
              <span className="stat-number">🔐</span>
              <span 
                className="stat-label"
                style={{
                  color: 'white',
                  opacity: 1,
                  textShadow: '0 1px 3px rgba(0, 0, 0, 0.8)',
                  fontWeight: '600',
                  fontSize: '0.9rem'
                }}
              >
                AES-256 암호화
              </span>
            </div>
            <div className="stat-item">
              <span className="stat-number">🌐</span>
              <span 
                className="stat-label"
                style={{
                  color: 'white',
                  opacity: 1,
                  textShadow: '0 1px 3px rgba(0, 0, 0, 0.8)',
                  fontWeight: '600',
                  fontSize: '0.9rem'
                }}
              >
                Zero-Knowledge
              </span>
            </div>
            <div className="stat-item">
              <span className="stat-number">📱</span>
              <span 
                className="stat-label"
                style={{
                  color: 'white',
                  opacity: 1,
                  textShadow: '0 1px 3px rgba(0, 0, 0, 0.8)',
                  fontWeight: '600',
                  fontSize: '0.9rem'
                }}
              >
                반응형 디자인
              </span>
            </div>
          </div>
        </div>
      </header>

      <div className="guide-container">
        <div className="guide-layout">
          
          {/* 사이드 네비게이션 */}
          <nav className="guide-nav">
            <div className="nav-sticky">
              <h3>📑 목차</h3>
              <ul className="nav-list">
                {sections.map(section => (
                  <li 
                    key={section.id}
                    className={activeSection === section.id ? 'active' : ''}
                  >
                    <button 
                      onClick={() => scrollToSection(section.id)}
                      className="nav-button"
                    >
                      <span className="nav-icon">{section.icon}</span>
                      <span className="nav-text">{section.title}</span>
                    </button>
                  </li>
                ))}
              </ul>
              
              <div className="nav-footer">
                <Button
                  variant="outline"
                  size="sm"
                  onClick={() => window.location.href = '/'}
                  style={{ marginBottom: '8px' }}
                >
                  🏠 메인으로
                </Button>
                <Button
                  variant="outline"
                  size="sm"
                  onClick={() => window.history.back()}
                >
                  ← 뒤로가기
                </Button>
              </div>
            </div>
          </nav>

          {/* 메인 콘텐츠 */}
          <main className="guide-content">
            
            {/* 각 섹션 컴포넌트들 */}
            <GettingStartedSection />
            <PasswordManagementSection />
            <SearchSortSection />
            <TagsSection />
            <ShareSection />
            <SecuritySection />
            <SettingsSection />
            <AdvancedSection />
            <TipsSection />

          </main>
        </div>
      </div>
    </div>
  );
}

export default UserGuide;